/**
 * useGlobalShortcut — fires a callback on Cmd+K (macOS) / Ctrl+K (Win/Linux).
 * spec-46 W3 — global search omnibar shortcut.
 *
 * Pattern: follows useInboxKeyboard.ts (addEventListener + cleanup).
 * Does NOT add any new packages.
 */

import { useEffect } from 'react';

/**
 * Attach a keydown listener for Cmd/Ctrl + <key>.
 * @param key  - The key to listen for (case-insensitive), e.g. 'k'
 * @param callback - Called when the shortcut fires
 * @param enabled  - When false, listener is not attached (default: true)
 */
export function useGlobalShortcut(
  key: string,
  callback: () => void,
  enabled = true,
): void {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === key.toLowerCase()) {
        e.preventDefault();
        callback();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [key, callback, enabled]);
}
